import { createSelector } from 'reselect';

import { selectedCourseSelector, courseValidationSelector } from '../../../reducers/selectors';

const courseSelector = createSelector(
  selectedCourseSelector,
  courseValidationSelector,

  (selectedCourse, validatedCourse) => {
    let course = 'validatedPeriodsData';
    if (selectedCourse?.underReview === true) {
      course = 'underReview';
    } else if (validatedCourse !== false) {
      course = 'validatedPeriodsData';
    } else if (validatedCourse === false) {
      course = 'unvalidatedPeriodsData';
    }
    return course;
  },
);

export default courseSelector;
